import React from 'react';
import { Container, Text } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../../../core/helpers/isMobile';
import { gameStore } from '../../../../../store/gameStore';

// import { applicationStore } from '../../../../../store/applicationStore';

const FreeSpinContent = observer(() => {
  // const {
  //   canvasTranslationKeys: { FREE_SPINS_LEFT },
  // } = applicationStore;

  return (
    <Container x={isMobile() ? 67 : 130} y={isMobile() ? 40 : 80} name='FreeSpinContent'>
      <Text
        text={gameStore.gameFreeSpinRemainingCount}
        anchor={0.5}
        resolution={2}
        style={{
          _fontSize: isMobile() ? 35 : 50,
          _fontWeight: 700,
          _fill: '#FFFFFF',
          _fontFamily: 'poppinsMedium',
        }}
      />
      <Text
        text='FREE SPINS LEFT'
        anchor={0.5}
        y={isMobile() ? 34 : 60}
        resolution={2}
        style={{
          _align: 'center',
          _fontSize: isMobile() ? 17 : 30,
          _fontWeight: 500,
          _fill: '#FFFFFF',
          _wordWrap: true,
          _wordWrapWidth: isMobile() ? 110 : 170,
          _fontFamily: 'poppinsMedium',
        }}
      />
    </Container>
  );
});

export default FreeSpinContent;
